import {
  printDebugLog
} from "../../constants/constant";
import { snpAxios } from "../../components/global/api";
import axios from "axios";

export const printBillAPI = async(url) => {
  //printLog("printBillAfterPay",e.target.id);
  let data = {};
  printDebugLog("printBillAfterPay => ", url);
  return await axios.get(url);
};

export const initiateEpayLinkAPI = (url, requestData) => {
  // //printLog("data", billDetails);
  const data = {
    jcJson: requestData,
  };
  printDebugLog("epay", data);
  const response = snpAxios.post(url, data);
  return response.data;
};

export const settleBillAPI = (url, requestData) => {
  let data = { jcJson: requestData };
  delete data.jcJson.royalityPoint;
  //printLog("finalSettle", saveBillData);
  return snpAxios.post(url, data);
};

export const initiatePaymentAPI = async (url, requestData) => {
  // variables needed
  let data = { jcJson: requestData };
  delete data.jcJson.royalityPoint;
  //printLog("initiatePayment", saveBillData);
  return await snpAxios.post(url, data);
};

export const kotPrintAPI = async (url, requestData) => {
  if (url && requestData) {
    let data = { jcJson: requestData };
    //printLog("kotprint => ", settleData);
    return await snpAxios.post(url, data);
  }
};

export const saveBillAPI = async (url, requestData) => {
  if (url && requestData) {
    let data = { jcJson: requestData };
    //printLog("kotprint => ", settleData);
    return await snpAxios.post(url, data);
  }
};
export const generateBillAPI = async (url, requestData) => {
  let data = { jcJson: requestData };
  delete data.jcJson.royalityPoint;
  //printLog("generateBill", saveBillData);
  return await snpAxios.post(url, data);
};

export const deleteBillAPI = async (url) => {
  //printLog("deleteEntireBill => ", dUrl);
  return await axios.get(url);
};

export const cancelBillAPI = (url, requestData) =>
  snpAxios.post(url, { jcJson: requestData });

export const payLaterAPI = async (url, requestData) => {
  let data = { jcJson: requestData };

  delete data.jcJson.royalityPoint;

  //printLog("initiatePayment", saveBillData);
  return await snpAxios.post(url, data);
};

export const updateFoodStatusAPI = (url, requestData) => {
  let data = { jcJson: requestData };
  //printLog("kotprint => ", settleData);
  return snpAxios.post(url, data);
};

// const buildCompleteBillDataRequestPayload = (allBillData={}, deviceInfo={}, shopHash={},partialPayDetails={}) => {
//   const {billDetails, billPaymentDetails, billCustomerDetails, billItems, billHotelDetails, billRiderDetails} = allBillData;
//   let mOnlinePayEnb = Number(billPaymentDetails.onlinePay) !== 0.0;
//   let mCashPayEnb = Number(billPaymentDetails.cashPay) !== 0.0;
//   var today = new Date();
//   var time =
//     " " +
//     today.getHours() +
//     ":" +
//     today.getMinutes() +
//     ":" +
//     today.getSeconds();
//   return   {
//       apiToken: CART_INITIAL_STATE.apiToken,
//       shopHash: shopHash.id,
//       value_2: billItems,
//       billNo: billDetails.billNo,
//       tableId: billDetails.tableId,
//       custId: billCustomerDetails.custId,
//       custMob: billCustomerDetails.custMob,
//       custEmail: billCustomerDetails.custEmail,
//       address: billCustomerDetails.address,
//       custName: billCustomerDetails.custName,
//       custGstDetails: billCustomerDetails.custGstDetails,
//       custCompanyName: billCustomerDetails.custCompanyName,
//       cartType: shopHash.cartType,
//       payMedium: getPayMedium(billPaymentDetails.isCashPayEnabled, billPaymentDetails.isOnlinePayEnabled),
//       onlinePayThrough: !billPaymentDetails.isOnlinePayEnabled
//         ? ""
//         : billPaymentDetails.onlinePayThrough,
//       onlinePayMedium: !billPaymentDetails.isOnlinePayEnabled ? "" : billPaymentDetails.onlinePayMedium,
//       cashPayThrough: !billPaymentDetails.isCashPayEnabled ? "" : billPaymentDetails.cashPayThrough,
//       onlinePay: parseFloat(billPaymentDetails.onlinePay),
//       cashPay: parseFloat(billPaymentDetails.cashPay),
//       cashTender: billPaymentDetails.isCashPayEnabled ? parseFloat(billPaymentDetails.cashTender) : 0.0,
//       cashReturn: billPaymentDetails.isCashPayEnabled ? parseFloat(billPaymentDetails.cashReturn) : 0.0,
//       roundOff: parseFloat(billDetails.roundOff),
//       cgst: parseFloat(billDetails.cgst),
//       sgst: parseFloat(billDetails.sgst),
//       cgstAmt: parseFloat(billDetails.cgstAmt),
//       sgstAmt: parseFloat(billDetails.sgstAmt),
//       isGstAllowed: billDetails.isGstAllowed,
//       partialBillAudit: partialPayDetails,
//       isMobile: deviceInfo.isMobile || deviceInfo.isTablet,
//       billType: parseInt(billDetails.billingType),
//       subTotal: parseFloat(billDetails.subTotal),
//       total: parseFloat(billDetails.total),
//       pointRedeem: billDetails.isPointAdded
//         ? parseFloat(billDetails.pointRedeem)
//         : 0.0,
//       createdAt: billDetails.createdAt + time,
//       billStatus: BillStatus.INITIATED,
//       takenDenom: billDetails.offerDenom,
//       takenOffrAmt: billDetails.offerAmt,
//       settleDown:
//         billDetails.billingType === InternalBillType.BookTable ? true : false,
//       delvName: isEmpty(billPaymentDetails.delvNameOth)
//         ? billPaymentDetails.delvName
//         : billPaymentDetails.delvNameOth,
//       delvCharge: billPaymentDetails.deliveryCharge,
//       isGenerateBill: true,
//       hotelBillId: billHotelDetails.hotelBillId,
//       hotelBillNo: billHotelDetails.hotelBillNo,
//       homeDelvId: billDetails.homeDelvId,
//       homeDelvOtp: billDetails.homeDelvOtp,
//     };
// };
